import React, { FC } from "react";
import profileIcon from "@danskernesdigitalebibliotek/dpl-design-system/build/icons/basic/icon-profile.svg";
import MenuNotLoggedInContent from "./menu-not-logged-in/menu-not-logged-in";
import { isAnonymous, isUnregistered } from "../../core/utils/helpers/user";
import MenuLoggedIn from "./menu-logged-in/menu-logged-in";
import { useText } from "../../core/utils/text";
import { useModalButtonHandler } from "../../core/utils/modal";
import TextLineSkeleton from "../../components/skeletons/TextLineSkeleton";
import { getModalIds } from "../../core/utils/helpers/modal-helpers";
import MenuUserUnregistered from "./menu-user-unregistered/menu-user-unregistered";
import { usePatronData } from "../../core/utils/helpers/usePatronData";
import Translations from "./translations/Translations";
import { isEnterOrSpacePressed } from "../../core/utils/helpers/general";
import { useConfig } from "../../core/utils/config";
import MenuUniloginPatronLogin from "./menu-unilogin-patron-login/menu-unilogin-patron-login";

interface MenuProps {
  pageSize: number;
}

const Menu: FC<MenuProps> = ({ pageSize }) => {
  const { open } = useModalButtonHandler();
  const t = useText();
  const {
    userMenuAuthenticated: userMenuAuthenticatedModalId,
    userMenuAnonymous: userMenuAnonymousModalId,
    userMenuUnregistered: userMenuUnregisteredModalId
  } = getModalIds();
  const { isLoading, data: userData } = usePatronData();
  // A Unilogin student is logged in without being a patron.
  const config = useConfig();
  const uniloginUserId = config("uniloginUserIdConfig") || null;
  const openMenuOptions = { updateUrl: false };
  const openMenu = () => {
    // Without a patron the menu only offers to log out.
    if (isUnregistered() || uniloginUserId) {
      open(userMenuUnregisteredModalId as string, openMenuOptions);
      return;
    }
    if (isAnonymous()) {
      open(userMenuAnonymousModalId as string, openMenuOptions);
      return;
    }
    open(userMenuAuthenticatedModalId as string, openMenuOptions);
  };
  const getAriaLabel = () => {
    if (isLoading) {
      return t("searchHeaderLoginText");
    }
    return userData?.patron || uniloginUserId
      ? t("menuUserIconAriaLabelText")
      : t("menuUserIconAriaLabelLoggedOutText");
  };

  /*
  TODO: Add data-cy to all elements regarding cypress tests in this file,
  for reduced flakyness.
  */
  return (
    <div className="header__profile-traslation-container">
      <Translations />
      <button
        className="header__button btn-ui"
        data-cy="header-menu-profile-button"
        type="button"
        aria-label={getAriaLabel()}
        onMouseUp={() => openMenu()}
        onKeyUp={(e) => {
          if (isEnterOrSpacePressed(e.key)) {
            openMenu();
          }
        }}
        tabIndex={0}
      >
        <img src={profileIcon} className="header__button-icon" alt="" />
        <span className="header__button-text">
          {isLoading ? (
            <TextLineSkeleton width={50} />
          ) : (
            userData?.patron?.name ||
            uniloginUserId ||
            t("searchHeaderLoginText")
          )}
        </span>
      </button>
      <MenuLoggedIn pageSize={pageSize} />
      <MenuUserUnregistered />
      <MenuNotLoggedInContent />
      <MenuUniloginPatronLogin />
    </div>
  );
};

export default Menu;
